import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { ConnectEvents, ConnectEventSources, useTrackConnectEvent } from '../../../services/shipstation-connect/segment-tracking';
import { useGetConnectDownloadData } from './use-get-connect-download-data';
import styles from './style.module.less';

export const DownloadConnectButton = () => {
  const { buttonMessage, downloadUrl } = useGetConnectDownloadData();

  const trackDownload = useTrackConnectEvent(ConnectEvents.CONNECT_DOWNLOAD_CLICKED, ConnectEventSources.CONNECT_SETTINGS_PAGE);

  return (
    <div className={styles['install-button']}>
      <Button
        href={downloadUrl}
        onClick={() => trackDownload({ downloadUrl })}
        otherProperties={{ download: true }}
        theme={THEME_CONSTANTS.primary}
      >
        <FormattedMessage {...buttonMessage} />
      </Button>
    </div>
  );
};
